import { useTranslation } from 'react-i18next'
import { Text, Link } from '@machobear/design-system'

export const Footer = () => {
  const { t } = useTranslation()

  return (
    <Text tone="tertiary">
      {t('Need help?')}
      &nbsp;
      <Link
        target="_blank"
        rel="noopener noreferrer"
        href="mailto:support@liv.rent"
        style={{ color: '#4964E9', fontWeight: 500 }}
      >
        {t('Contact us')}
      </Link>
    </Text>
  )
}
